import { SearchUrlParamBuilder } from '@/core/utils'
import axios from 'axios'

const URL_PATH = 'api/adesao'

class ItensAdesaoApiClient {
	async buscarItensQueJaEstaNaAdesao(paginacao, idAdesao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idAdesao}/itens`,
			pagingAndSorting: paginacao,
		}).build()

		return await axios.get(url)
	}
}

export default new ItensAdesaoApiClient()
